import type { IteroLiveCheck, IteroStatus } from '../../../../services/iteroConnection';
import { formatDateTime } from '../../../../utils/dates';
import { describeIteroStatus, describeTestResult } from './iteroConnectionCopy';

interface IteroStatusLineProps {
    status: IteroStatus;
}

export function IteroStatusLine({ status }: IteroStatusLineProps) {
    const summary = describeIteroStatus(status, Date.now(), formatDateTime);
    const dotClass = !summary.connected
        ? 'bg-gray-300'
        : summary.expiry?.expired
          ? 'bg-red-500'
          : 'bg-green-500';

    return (
        <span className="flex flex-col gap-0.5 min-w-0">
            <span
                className={`flex items-start gap-1.5 min-w-0 text-[12px] ${summary.connected ? 'text-gray-600' : 'text-gray-500'}`}
            >
                <span className={`w-1.5 h-1.5 mt-1.5 rounded-full shrink-0 ${dotClass}`} />
                <span className="min-w-0 break-words">
                    {summary.headline}
                    {summary.expiry && (
                        <>
                            {' · '}
                            <span className={summary.expiry.expired ? 'text-red-600' : undefined}>
                                {summary.expiry.text}
                            </span>
                        </>
                    )}
                </span>
            </span>
            {summary.sharedLine && (
                <span className="text-[11px] text-gray-400 pl-3 break-words">
                    {summary.sharedLine}
                </span>
            )}
        </span>
    );
}

export function IteroStatusSkeleton() {
    return <div className="h-3.5 w-40 bg-gray-200 rounded animate-pulse" />;
}

export function IteroTestResultLine({ live }: { live: IteroLiveCheck | undefined }) {
    const result = describeTestResult(live);
    return (
        <span
            className={`text-[12px] font-medium break-words ${result.ok ? 'text-green-700' : 'text-red-600'}`}
        >
            {result.text}
        </span>
    );
}
